module.exports = __webpack_public_path__ + "static/media/Original Korean - Teaching - Road to Enlightenment (load_4).e26cf581.txt";